import request from "./request";
import axios from "axios";
// import store from '../store'


// console.log(request.interceptors.request)
// console.log(store.state.lang)
// request.headers['Accept-Language'] = store.state.lang
/**
 * 登录
 * @param {Object} params - 参数对象
 * @param {string} params.phone - 手机号
 * @param {string} params.email - 邮箱
 * @param {string} params.verificationCode - 验证码 
 * @param {string} params.password - 密码 验证码二选一
 * @returns {Promise} - 返回 Promise 对象
 */

export const Login = (params) => {
    return request({
        url: '/ppt-talk/user/login',
        method: "post",
        data: params
    });
}

/**
 * google登录
 * @param {Object} params - 参数对象
 * @param {string} params.credential 
 * @returns {Promise} - 返回 Promise 对象
 */

export const googleLogin = (params) => {
    return request({
        url: '/ppt-talk/user/googleLogin',
        method: "post",
        data: params
    });
}

/**
 * 退出登录
 * @returns {Promise} - 返回 Promise 对象
 */

export const Logout = (params = {}) => {
    return request({
        url: '/ppt-talk/user/logout',
        method: "post",
        data: params
    });
}



/**
 * 编辑用户信息
 * @returns {Promise} - 返回 Promise 对象
 *  @param {string} params.userId - userid
 *  @param {string} params.userName - 名称
 *  @param {string} params.avatar - 头像
 *  @param {string} params.password - 密码
 *  @param {string} params.verificationCode - 验证码
 */

export const editUser = (params = {}) => {
    return request({
        url: '/ppt-talk/user/edit',
        method: "post",
        data: params
    });
}

/**
 * 获取用户信息
 * @returns {Promise} - 返回 Promise 对象
 *  @param {string} params.userId - 手机号 或邮箱
 */

export const getUser = (params = {}) => {
    return request({
        url: '/ppt-talk/user/info',
        method: "post",
        data: params
    });
}


/**
 * 发送验证码
 * @param {Object} params - 参数对象
 * @param {string} params.targetAddress - 手机号 或邮箱
 * @param {string} params.captchaType - 验证码类型
 * @param {string} params.sendType - email邮箱，mobile 手机
 * @returns {Promise} - 返回 Promise 对象
 */
export const sendCaptcha = (params) => {
    return request({
        url: '/ppt-talk/user/sendCaptcha',
        method: "post",
        data: params
    });
}


/**
 * 注册
 * @param {Object} params - 参数对象
 * @param {string} params.email - 手机号 或邮箱
 * @param {string} params.password - 密码
 * @param {string} params.code - 验证码
 * @returns {Promise} - 返回 Promise 对象
 */
export const regist = (params) => {
    return request({
        url: '/ppt-talk/user/regist',
        method: "post",
        data: params
    });
}


/**
 * 获取PPT文档列表
 * @param {Object} params - 参数对象
 * @param {Number} params.pages - 页码
 * @returns {Promise} - 返回 Promise 对象
 */
export const pptList = (params = {}) => {
    params.size = 1000
    return request({
        url: '/ppt-talk/doc/list',
        method: "post",
        data: params
    });
}

/**
 * 上传PPT文档
 * @param {Object} params - 参数对象
 * @param {file} params.file - 文档对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const UpLoadPPT = (params) => {
    let mData = new FormData()
    mData.append('file', params.file)
    return request({
        url: '/ppt-talk/doc/upload',
        method: "post",
        data: mData,
        headers: { "Content-Type": "multipart/form-data" }
    });
}

/**
 * 删除PPT文档
 * @param {Object} params - 参数对象
 * @param {string} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const DelPPT = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/remove',
        method: "post",
        data: params
    });
}

/**
 * PPT文档详情
 * @param {Object} params - 参数对象
 * @param {string} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const PPTInfo = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/detail',
        method: "post",
        data: params
    });
}

/**
 * PPT文档详情
 * @param {Object} params - 参数对象
 * @param {string} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const PPTInfoShare = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/share',
        method: "post",
        data: params
    });
}



/**
 * 获取形象列表
 * @param {Object} params - 参数对象
 * @param {Object} params.imageType - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const FigureList = (params = {}) => {
    return request({
        url: '/ppt-talk/image/list',
        method: "post",
        data: params
    });
}

/**
 * 删除形象
 * @param {Object} params - 参数对象
 * @param {Object} params.id - 形象id
 * @returns {Promise} - 返回 Promise 对象
 */
export const delFigure = (params = {}) => {
    return request({
        url: '/ppt-talk/image/delete',
        method: "post",
        data: params
    });
}


/**
 * 文档旁白生成语音及口型
 * @param {Object} params - 参数对象
 * @param {Object} params.id - 文档ID
 * @param {Object} params.pageNum - 文档页码
 * @returns {Promise} - 返回 Promise 对象
 */
export const playBackCreate = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/playBackCreate',
        method: "post",
        data: params
    });
}

/**
 * 文档生成知识库
 * @param {Object} params - 参数对象
 * @param {Object} params.documentId - 文档ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateKnowledge = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/generateKnowledge',
        method: "post",
        data: params
    });
}


/**
 * 生成播放任务
 * @param {Object} params - 参数对象
 * @param {Object} params.documentId - 文档ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const generatePlay = (params = {}) => {
    params.pageNum = 0
    return request({
        url: '/ppt-talk/doc/generatePlay1',
        method: "post",
        data: params
    });
}





/**
 * 编辑PPT文档某页旁白 或者修改文档标题
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @param {Number} params.documentName - 文档标题
 * @param {Object[]} params.voiceOverPages - 文档页id
 * @param {Number} params.voiceOverPages[].documentPageId - 文档页id
 * @param {string} params.voiceOverPages[].voiceOver - 文档页旁白
 * @returns {Promise} - 返回 Promise 对象
 */
// 管理所有请求的 cancel
const docEditCancels = {
    true: {},   // send=true 的请求
    false: {}   // send=false 的请求
};

let reqId = 0;
export const DocEdit = (params = {}, send = false) => {
    reqId += 1;
    const key = reqId + "_" + Date.now();

    // 如果 send=true，取消所有 send=false 的请求
    if (send === true) {
        Object.values(docEditCancels.false).forEach(cancel => {
            if (typeof cancel === "function") cancel("cancel");
        });
        docEditCancels.false = {};
    }

    // 先取消同 key 的请求（防止重复）
    if (docEditCancels[send][key]) {
        docEditCancels[send][key]("取消前一个 DocEdit 请求");
    }

    return request({
        url: '/ppt-talk/doc/edit',
        method: "post",
        data: params,
        cancelToken: new axios.CancelToken(function executor(c) {
            docEditCancels[send][key] = c;
        })
    }).finally(() => {
        // 请求完成后清理
        delete docEditCancels[send][key];
    });
}


/**
 * 获取PPT文档绑定的形象
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const GetDocFigure = (params = {}) => {
    return request({
        url: '/ppt-talk/image/setup/get',
        method: "post",
        data: params
    });
}


/**
 * 保存PPT文档绑定的形象
 * @param {Object} params - 参数对象
 * @param {Number} params.id - 数据id,可选,携带是修改,不带是新增
 * @param {Number} params.imageId - 形象id
 * @param {Number} params.documentId - 文档页id
 * @param {Number} params.wide - 形象宽
 * @param {Number} params.high - 形象高
 * @param {Number} params.x - 坐标x,横轴
 * @param {Number} params.y - 坐标y竖轴
 * @param {Number} params.voices - 音色
 * @param {Number} params.sex - 性别
 * @param {Number} params.languageCode - 音色code 
 * @param {Number} params.languageType - 音色类型 
 * @param {Number} params.local  
 * @returns {Promise} - 返回 Promise 对象
 */
export const SaveDocFigure = (params = {}) => {
    console.log(params)
    if (!params.id) {
        delete params.id
    }

    return request({
        url: '/ppt-talk/image/setup/save',
        method: "post",
        data: params
    });
}

/**
 * 获取权限列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const permiList = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/permi/list',
        method: "post",
        data: params
    });
}


/**
 * 设置文档权限
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档页id
 * @param {Number} params.permissionCode - 权限code
 * @returns {Promise} - 返回 Promise 对象
 */
export const permiSet = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/permi/settings',
        method: "post",
        data: params
    });
}


/**
 * 检查当前文档是否有权限
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const permiCheck = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/permi/orNo',
        method: "post",
        data: params
    });
}

/**
 * 保存素材详情
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const splitSegment = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/split-segment',
        method: "post",
        data: params
    });
}

/**
 * 获取当前文档的权限
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const permiGet = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/permi/get',
        method: "post",
        data: params
    });
}


/**
 * 文档是否是作者本人
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const fromAuthor = (params = {}, headers = {}) => {

    return request({
        url: '/ppt-talk/doc/fromAuthor',
        method: "post",
        data: params,
    });
}



/**
 * 上传文件到谷歌---获取预签名的上传地址
 * @param {Object} params - 参数对象
 * @param {Number} params.fileName - 文件名称
 * @returns {Promise} - 返回 Promise 对象
 */
export const preSignedUrl = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/preSignedUrl',
        method: "post",
        data: params
    });
}



/**
 * 上传存储桶文件地址到服务端
 * @param {Object} params - 参数对象
 * @param {Number} params.pdfUrl - pdfUrl文件地址
 * @param {Number} params.pdfName - pdf文件名
 * @param {Number} params.pdfPageUrl - pdfUrl页的一个地址集合
 * @returns {Promise} - 返回 Promise 对象
 */
export const uploadPDFURL = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/upload/v1',
        method: "post",
        data: params
    });
}



/**
 * 创建会话获取sessionId
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const createSession = (params = {}) => {
    return request({
        url: '/ppt-talk/dialogue/createSession',
        method: "post",
        data: params
    });
}



/**
 * 对话
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @param {Number} params.sessionId - sessionId
 * @param {Number} params.content - 对话内容
 * @param {Number} params.pageNum - 第几页
 * @returns {Promise} - 返回 Promise 对象
 */
export const dialogue = (params = {}, headers = {}) => {

    return request({
        url: '/ppt-talk/dialogue',
        method: "post",
        data: params,
        // headers: { "Content-Type": "multipart/form-data" }
    });
}


/**
 * 语音转文字
 * @param {Object} params - 参数对象
 * @param {Number} params.blob - 语音blob
 * @returns {Promise} - 返回 Promise 对象
 */
export const dialogueToText = (params = {}) => {

    let recfile = new File([params.blob], 'audio.wav', { type: 'audio/wav', lastModified: new Date() });
    let mData = new FormData()
    mData.append('file', recfile)
    // mData.append('sseId',params.sseId)
    return request({
        url: '/ppt-talk/dialogue/toText',
        method: "post",
        data: mData,
        headers: { "Content-Type": "multipart/form-data" }
    });
}

/**
 * 获取知识库
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const knowledge = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/getKnowledge',
        method: "post",
        data: params
    });
}


/**
 * 生成知识库
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const generate_Knowledge = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/generateKnowledge',
        method: "post",
        data: params
    });
}
/**
 * 保存知识库
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @param {Number} params.knowledge - 文本
 * @returns {Promise} - 返回 Promise 对象
 */
export const saveKnowledge = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/saveKnowledge',
        method: "post",
        data: params
    });
}

/**
 * 自动生成旁白
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateVoiceOver = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/generateVoiceOver',
        method: "post",
        data: params
    });
}

/**
 * 流式自动生成旁白
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
//  * @param {Number} params.pageNum - 页码 + 1
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateVoiceOver1 = (params) => {



    return request({
        url: '/ppt-talk/doc/generateVoiceOver/sse',
        method: "post",
        data: params
    });
}

/**
 * 流式自动生成旁白
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateSse = (params) => {



    return request({
        url: '/ppt-talk/doc/generateVoiceOver/sse/v1',
        method: "post",
        data: params
    });
}
/**
 * 自动生成旁白
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateSetting = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/generateVoiceOver/setting',
        method: "post",
        data: params
    });
}

/**
 * 获取语种
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const subtitleLanguages = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/subtitle-languages',
        method: "post",
        data: params
    });
}



/**
 * 生成旁白时，创建的sessionId
 * @param {Object} params - 参数对象
 * @param {Number} params.documentBid - 文档bid
 * @param {Number} params.pageNum - 页码 + 1
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateSessionCreate = (params) => {
    return request({
        url: '/ppt-talk/doc/voiceover/generateVoiceOver/session/create',
        method: "post",
        data: params
    });
}

/**
 * 音色列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const voiceLists = (params = {}) => {
    return request({
        url: '/ppt-talk/voices/list',
        method: "post",
        data: params
    });
}



/**
 * 首页音色列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const VoiceList = (params = {}) => {
    return request({
        url: '/ppt-talk/voices/menu/list',
        method: "post",
        data: params
    });
}

/**
 * 音色搜索列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const VoiceDownList = (params = {}) => {
    return request({
        url: '/ppt-talk/voices/menu/down',
        method: "post",
        data: params
    });
}

/**
 * 获取引导信息Get
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const guideGet = (params = {}) => {
    return request({
        url: '/ppt-talk/guide/get',
        method: "post",
        data: params
    });
}


/**
 * 保存引导信息
 * @param {Object} params - 参数对象
 * @param {Number} params.guideComplete 
 * @param {Number} params.versionName 
 * @returns {Promise} - 返回 Promise 对象
 */
export const guideSave = (params = {}) => {
    return request({
        url: '/ppt-talk/guide/edit',
        method: "post",
        data: params
    });
}

/**
 * 生成默认文档
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const generateDefaultDoc = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/generateDefaultDoc',
        method: "post",
        data: params
    });
}


/**
 * 素材列表
 * @param {Object} params - 参数对象
 * @param {Object} params.assetType - 素材类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const assetList = (params = {}) => {
    params.size = 100
    return request({
        url: '/ppt-talk/asset/list',
        method: "post",
        data: params
    });
}


/**
 * 删除素材
 * @param {Object} params - 参数对象
 * @param {Object[]} params.bids - 素材id列表
 * @returns {Promise} - 返回 Promise 对象
 */
export const delAsset = (params = {}) => {
    return request({
        url: '/ppt-talk/asset/remove',
        method: "post",
        data: params
    });
}


/**
 * 新增或修改素材
 * @param {Object} params - 参数对象
 * @param {Object} params.bid - 素材id
 * @param {Object} params.assetName - 素材名称
 * @param {Object} params.assetType - 素材类型
 * @param {Object} params.assetUrl - 素材地址
 * @returns {Promise} - 返回 Promise 对象
 */
export const saveAsset = (params = {}) => {
    return request({
        url: '/ppt-talk/asset/save',
        method: "post",
        data: params
    });
}





/**
 * 获取文档的素材
 * @param {Object} params - 参数对象
 * @param {Object} params.bid - id
 * @returns {Promise} - 返回 Promise 对象
 */
export const documentAsset = (params = {}) => {
    return request({
        url: '/ppt-talk/document/asset/get',
        method: "post",
        data: params
    });
}



/**
 * 翻译
 * @param {Object} params - 参数对象
 * @param {Object} params.content - 翻译文本
 * @param {Object} params.languages - 翻译语种
 * @param {Object} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const translation = (params = {}) => {
    return request({
        url: '/ppt-talk/doc/translation',
        method: "post",
        data: params
    });
}




/**
 * 保存分享信息
 * @param {Object} params - 参数对象
 * @param {Object} params.documentId - 文档id
 * @param {Object} params.name - 分享名称
 * @param {Object} params.description - 详情
 * @param {Object} params.label - 标签
 * @param {Object} params.category - 类型
 * @param {Object} params.link - 分享链接
 * @returns {Promise} - 返回 Promise 对象
 */
export const communitySave = (params = {}) => {
    return request({
        url: '/ppt-talk/community/save',
        method: "post",
        data: params
    });
}

/**
 * 获取分享信息
 * @param {Object} params - 参数对象
 * @param {Object} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const communityInfo = (params = {}) => {
    return request({
        url: '/ppt-talk/community/info',
        method: "post",
        data: params
    });
}


/**
 * 获取分享类型
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const communityType = (params = {}) => {
    return request({
        url: '/ppt-talk/community/type',
        method: "post",
        data: params
    });
}



/**
 * 创建订单
 * @param {Object} params - 参数对象
 * @param {Object} params.productId - 商品id
 * @param {Object} params.quantity - 数量
 * @param {Object} params.totalAmount - 总金额
 * @returns {Promise} - 返回 Promise 对象
 */
export const orderCreate = (params = {}) => {
    return request({
        url: '/ppt-talk/order/create',
        method: "post",
        data: params
    });
}


/**
 * 取消订单
 * @param {Object} params - 参数对象
 * @param {Object} params.orderId - 订单id
 * @returns {Promise} - 返回 Promise 对象
 */
export const orderCancel = (params = {}) => {
    return request({
        url: '/ppt-talk/order/cancel',
        method: "post",
        data: params
    });
}


/**
 *订阅
 * @param {Object} params - 参数对象
 * @param {Object} params.orderId - 订单id
 * @returns {Promise} - 返回 Promise 对象
 */
export const payment = (params = {}) => {
    return request({
        url: '/ppt-talk/subscription',
        method: "post",
        data: params
    });
}

/**
 *管理订阅
 * @param {Object} params - 参数对象
 * @param {Object} params.subscriptionsId - 订单id
 * @returns {Promise} - 返回 Promise 对象
 */
export const payManage = (params = {}) => {
    return request({
        url: '/ppt-talk/subscription/manage',
        method: "post",
        data: params
    });
}


/**
 *获取用户的订阅
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const subscription = (params = {}) => {
    return request({
        url: '/ppt-talk/subscription/active',
        method: "post",
        data: params
    });
}

/**
 *商品列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const products = (params = {}) => {
    return request({
        url: '/ppt-talk/products/list',
        method: "post",
        data: params
    });
}


/**
 *获取套餐使用情况
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const membership = (params = {}) => {
    return request({
        url: '/ppt-talk/membership/rights',
        method: "post",
        data: params
    });
}



/**
 *获取套餐列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const membershipList = (params = {}) => {
    return request({
        url: '/ppt-talk/membership/detail/list',
        method: "post",
        data: params
    });
}



/**
 *Credit 消耗列表
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const CreditLedgerList = (params = {}) => {
    return request({
        url: '/ppt-talk/credit/ledger/list',
        method: "post",
        data: params
    });
}




/**
 *查询订单状态
 * @param {Object} params - 参数对象
 * @param {Object} params.orderId - 订单id
 * @returns {Promise} - 返回 Promise 对象
 */
export const getOrder = (params = {}) => {
    return request({
        url: '/ppt-talk/order/get',
        method: "post",
        data: params
    });
}


/**
 *优惠卷到期时间
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const couponsTimeOut = (params = {}) => {
    return request({
        url: '/ppt-talk/subscription/couponsTimeOut',
        method: "post",
        data: params
    });
}




/**
 *获取社区列表
 * @param {Object} params - 参数对象
 * * @param {Object} params.current - 当前页
 * * @param {Object} params.size - 页数
 * * @param {Object} params.keyword - 关键词
 * * @param {Object} params.category - 类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const CommunityList = (params = {}) => {
    return request({
        url: '/ppt-talk/community/list',
        method: "post",
        data: params
    });
}


/**
 *获取社区列表分类
 * @param {Object} params - 参数对象
 * @returns {Promise} - 返回 Promise 对象
 */
export const CommunityType = (params = {}) => {
    return request({
        url: '/ppt-talk/community/type',
        method: "post",
        data: params
    });
}



/**
 *获取文件夹列表
 * @param {Object} params - 参数对象
 * @param {Object} params.bid - 文件夹ID
 * @param {Object} params.parentBid - 父文件夹ID
 * @param {Object} params.name - 文件夹名称
 * @param {Object} params.type - 文件夹类型 // document  asset
 * @param {Object} params.delete - 确认删除文件夹 //false  true
 * @returns {Promise} - 返回 Promise 对象
 */
export const FolderList = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/list',
        method: "post",
        data: params
    });
}



/**
 *创建文件夹
 * @param {Object} params - 参数对象
 * @param {Object} params.bid - 文件夹ID
 * @param {Object} params.parentBid - 父文件夹ID
 * @param {Object} params.name - 文件夹名称
 * @param {Object} params.type - 文件夹类型 // document  asset
 * @param {Object} params.delete - 确认删除文件夹 //false  true
 * @returns {Promise} - 返回 Promise 对象
 */
export const AddFolder = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/add',
        method: "post",
        data: params
    });
}


/**
 *删除文件夹
 * @param {Object} params - 参数对象
 * @param {Object} params.bid - 文件夹ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const DelFolder = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/remove',
        method: "post",
        data: params
    });
}




/**
 *修改文件夹名称
 * @param {Object} params - 参数对象
 * @param {Object} params.bid - 文件夹ID
 * @param {Object} params.name - 文件夹ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const EditFolder = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/modify',
        method: "post",
        data: params
    });
}



/**
 *文件夹树
 * @param {Object} params - 参数对象
 * @param {Object} params.type - 文件夹类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const FolderTree = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/tree',
        method: "post",
        data: params
    });
}



/**
 *添加文档到文件夹
 * @param {Object} params - 参数对象
 * @param {Object} params.folderId - 文件夹ID
 * @param {Object} params.documentId - 文件ID
 * @param {Object} params.documentName - 文件名称
 * @returns {Promise} - 返回 Promise 对象
 */
export const DocumentToFolder = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/document/add',
        method: "post",
        data: params
    });
}



/**
 *文件夹下的文档
 * @param {Object} params - 参数对象
 * @param {Object} params.folderId - 文件夹ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const folderDocumentList = (params = {}) => {
    return request({
        url: '/ppt-talk/folder/document/list',
        method: "post",
        data: params
    });
}




/**
 *工具列表
 * @param {Object} params - 参数对象
 * @param {Object} params.type - 工具类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const toolsList = (params = {}) => {
    return request({
        url: '/ppt-talk/tools/list',
        method: "post",
        data: params
    });
}


/**
 *获取工具类型列表
 * @param {Object} params - 参数对象
 * @param {Object} params.dataType - 工具类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const toolsTypeList = (params = { dataType: 'tools' }) => {

    return request({
        url: '/ppt-talk/dict/list',
        method: "post",
        data: params
    });
}


/**
 *保存文档素材
 * @param {Object} params - 参数对象
 * @param {Object} params.dataType - 工具类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const documentAssetSave = (params = {}) => {

    return request({
        url: '/ppt-talk/document/asset/save',
        method: "post",
        data: params
    });
}



/**
 *删除文档素材
 * @param {Object} params - 参数对象
 * @param {Object} params.dataType - 工具类型
 * @returns {Promise} - 返回 Promise 对象
 */
export const documentAssetRemove = (params = {}) => {

    return request({
        url: '/ppt-talk/document/asset/remove',
        method: "post",
        data: params
    });
}


/**
 *获取文档页的素材
 * @param {Object} params - 参数对象
 * @param {string} params.documentPageId - 文档页id
 * @param {string} params.documentBid - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const documentAssetByPageId = (params = {}) => {

    return request({
        url: '/ppt-talk/document/asset/byPageId',
        method: "post",
        data: params
    });
}
/**
 *获取文档所有页的素材
 * @param {Object} params - 参数对象
 * @param {string} params.documentId - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const documentAssetByDocumentId = (params = {}) => {

    return request({
        url: '/ppt-talk/document/asset/getByDocumentBid',
        method: "post",
        data: params
    });
}



/**
 *保存文档页的素材
 * @param {Object} params - 参数对象
 * @param {Array} params.paramList - 文档ID
 * @param {Object} params.paramList.documentBid - 文档ID
 * @param {Object} params.paramList.documentPageId - 文档页ID
 * @param {Object} params.paramList.pageNum - 文档页数
 * @param {Array} params.paramList.documentAssetDtoList - 文档素材列表
 * @returns {Promise} - 返回 Promise 对象
 */
export const assetSetUp = (params = {}) => {

    return request({
        url: '/ppt-talk/document/asset/asset-set-up',
        method: "post",
        data: params
    });
}


/**
 *发布文档
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档ID
 * @param {string} params.documentPublishLog - 文档ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const docPublish = (params = {}) => {

    return request({
        url: '/ppt-talk/publish/doc-publish',
        method: "post",
        data: params
    });
}

/**
 *查询发布信息
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档ID
 * @returns {Promise} - 返回 Promise 对象
 */
 export const lastPublish = (params = {}) => {

    return request({
        url: '/ppt-talk/publish/getLastPublish',
        method: "post",
        data: params
    });
}


/**
 * 生成播放任务
 * @param {Object} params - 参数对象
 * @param {string} params.documentId - 文档ID
 * @returns {Promise} - 返回 Promise 对象
 */
export const generatePlay1Publish = (params = {}) => {
    params.pageNum = 0
    return request({
        url: '/ppt-talk/publish/generatePlay1-publish',
        method: "post",
        data: params
    });
}



/**
 * 停止工作流
 * @param {Object} params - 参数对象
 * @param {string} params.taskId - 任务id
 * @returns {Promise} - 返回 Promise 对象
 */
export const stopWorkflow = (params = {}) => {
    return request({
        url: '/ppt-talk/workflow/stop',
        method: "post",
        data: params
    });
}





/**
 * 文档页问题组列表
 * @param {Object} params - 参数对象
 * @param {string} params.documentPageId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaGroudList = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/group/list',
        method: "post",
        data: params
    });
}
/**
 * 新增问题组
 * @param {Object} params - 参数对象
 * @param {Number} params.documentId - 文档id
 * @param {string} params.documentPageId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const addQaGroud = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/group/save',
        method: "post",
        data: params
    });
}
/**
 * 删除问题组
 * @param {Object} params - 参数对象
 * @param {string} params.bid - 问题组id
 * @returns {Promise} - 返回 Promise 对象
 */
export const removeQaGroud = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/group/remove',
        method: "post",
        data: params
    });
}

/**
 * 问题组下列表
 * @param {Object} params - 参数对象
 * @param {string} params.questionGroupBid - 问题组id
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaList = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/list',
        method: "post",
        data: params
    });
}

/**
 * 添加问题到问题组
 * @param {Object} params - 参数对象
 * @param {string} params.questionGroupBid - 问题组id
 * @param {Array<Object>} params.items - 问题列表
 * @param {string} params.items[].bid - 问题id
 * @param {string} params.items[].questionType - 问题类型
 * @param {string} params.items[].questionText - 问题文本
 * @param {string} params.items[].required - 是否必答
 * @param {string} params.items[].referenceAnswer - 参考答案
 * @param {string} params.items[].sort - 排序
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaSave = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/save',
        method: "post",
        data: params
    });
}


/**
 * 删除问题组下列表的问题
 * @param {Object} params - 参数对象
 * @param {string} params.bid - 问题id
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaRemove = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/remove',
        method: "post",
        data: params
    });
}



/**
 * 保存问题组的位置信息
 * @param {Object} params - 参数对象
 * @param {string} params.questionGroupBid - 问题组id
 * @param {string} params.documentPageId - 文档页id
 * @param {string} params.voiceOverStartIndex - 开始的旁白角标位置
 * @param {string} params.echoJson - 
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaSetup = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/setup',
        method: "post",
        data: params
    });
}


/**
 * 获取回答的用户列表
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档id
 * @param {string} params.documentVersion - 文档版本
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaUserList = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/answer/user/list',
        method: "post",
        data: params
    });
}

/**
 * 用户回答的详情
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档id
 * @param {string} params.userId - 用户id
 * @param {string} params.documentVersion - 文档版本
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaUserHistory = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/answer/user/history',
        method: "post",
        data: params
    });
}


/**
 * 获
 * @param {Object} params - 参数对象
 * @param {string} params.documentPageId - 文档页id
 * @returns {Promise} - 返回 Promise 对象
 */
export const qaStartTime = (params = {}) => {
    return request({
        url: '/ppt-talk/qa/startTime',
        method: "post",
        data: params
    });
}


/**
 * 查看演讲观看次数
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const speechWatchNum = (params = {}) => {
    return request({
        url: '/ppt-talk/watchRecord/anonymous/getSpeechWatchNum',
        method: "post",
        data: params
    });
}


/**
 * 查看趋势图
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档id
 * @param {string} params.days - 天数
 * @returns {Promise} - 返回 Promise 对象
 */
export const uniqueUserWatchCount = (params = {}) => {
    return request({
        url: '/ppt-talk/watchRecord/anonymous/uniqueUserWatchCount',
        method: "post",
        data: params
    });
}



/**
 * 获取用户观看历史统计列表
 * @param {Object} params - 参数对象
 * @param {string} params.documentBid - 文档id
 * @returns {Promise} - 返回 Promise 对象
 */
export const uniqueUserWatchDetails = (params = {}) => {
    params.size = 1000
    return request({
        url: '/ppt-talk/watchRecord/anonymous/user-watch-details',
        method: "post",
        data: params
    });
}